<span
  class="snack-wrapper"
  [class.info]="data.type === ESnackBarType.INFO"
  [class.text-warn]="data.type === ESnackBarType.ERROR"
>
  {{ data.messageI18n | translate: data.messageKeyI18n }}
</span>
